import Vue from 'vue'

import Modal from './modal'
import Toast from './toast'

import directives from '~/assets/vue/directives'
import { isSubtypeOf } from '~/assets/util/helpers'

directives.forEach((directive) => {
	Vue.directive(directive.name, directive)
})

Vue.use(Modal)
Vue.use(Toast)

Vue.prototype.$updateQuery = function (queryToUpdate = {}, paramsToPush = {}) {
	if (!this.$router || !this.$route) {
		return Promise.reject(new Error('Vue Router is not available!'))
	}

	const query = this.$route.query
	const params = this.$route.params
	const routeName = this.$route.name
	const sameParams = isSubtypeOf(query, queryToUpdate)

	if (sameParams) {
		// Do nothing if same query passed
		return Promise.resolve()
	}

	return this.$router
		.replace({
			name: routeName,
			query: { ...query, ...queryToUpdate },
			params: { ...params, ...paramsToPush }
		})
		.catch((failure) => {
			// eslint-disable-next-line no-console
			console.error(failure)

			if (this.$bugsnag) {
				this.$bugsnag.notify(failure, (event) => {
					event.severity = 'info'
				})
			}
		})
}
